// 返回栈按本次访问保存列表快照；不写入页面配置、localStorage 或分享链接。
export function captureFleetListViews (surface) {
  return Array.from(surface.querySelectorAll('.screen-fleet-list[data-fleet-node]')).map(root => {
    const body = root.querySelector('.screen-fleet-list__scroll')
    return body && {
      nodeId: root.getAttribute('data-fleet-node'), scope: root.getAttribute('data-fleet-scope'),
      x: body.scrollLeft, y: body.scrollTop,
      ...(typeof root.captureFleetView === 'function' ? { list: root.captureFleetView() } : {})
    }
  }).filter(Boolean)
}

export function fleetListRestore (origin, nodeId, scope) {
  if (!origin || !Array.isArray(origin.lists)) return null
  return origin.lists.find(entry => entry && entry.nodeId === String(nodeId) && entry.scope === scope &&
    Number.isFinite(entry.x) && entry.x >= 0 && Number.isFinite(entry.y) && entry.y >= 0) || null
}

export function restoreFleetListView (root, entry, rowId, canvas) {
  const body = root.querySelector('.screen-fleet-list__scroll')
  if (!body) return
  // 内容变短时浏览器自动收敛到新的边界；focus 不得再次滚动列表或外层画布。
  body.scrollLeft = entry.x
  body.scrollTop = entry.y
  if (rowId) {
    const active = root.ownerDocument.activeElement
    // 异步返回期间用户已移到其他控件，就只恢复位置，不抢走焦点。
    if (active !== canvas && active !== root.ownerDocument.body && !root.contains(active)) return
    const row = Array.from(root.querySelectorAll('[data-fleet-row]')).find(el => el.getAttribute('data-fleet-row-id') === rowId)
    const target = row || body
    target.focus({ preventScroll: true })
  }
}
